'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherAlertCircle, FeatherClock, FeatherFileText } from '@subframe/core';
import dynamic from 'next/dynamic';
import { Alert, Button, EmptyState, Loader } from '@/shared/components/ui';
import { useDocumentoDaAssinatura } from '../hooks/useDocumentoDaAssinatura';
import type { DocumentoDaAssinaturaDeTesteProps } from '../types';
const CarregandoDocumento = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div role="status" className="text-caption text-subtext-color flex min-h-[320px] items-center justify-center gap-2"><Loader size="small" />Carregando o documento de teste…</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};

// react-pdf é lib pesada: só entra quando há documento para mostrar.
const DocumentoPdfVisor = dynamic(() => import('@/shared/components/documentos/DocumentoPdfVisor'), {
  ssr: false,
  loading: () => <CarregandoDocumento />
});

/** Visualização do documento de teste da TELA-002, com erro, indisponibilidade e expiração. */
export const DocumentoDaAssinaturaDeTeste = t0 => {
  const $ = _c(26);
  const {
    superficie,
    simulacaoId,
    arquivoId,
    nomeDocumento
  } = t0;
  const {
    documento,
    tentarDeNovo,
    registrarFalhaDoVisor
  } = useDocumentoDaAssinatura(superficie, simulacaoId, arquivoId);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 id="documento-da-assinatura" className="text-heading-3 font-heading-3 text-default-font">Documento de teste</h2>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== nomeDocumento) {
    t2 = <p className="text-body text-subtext-color mt-1 break-words">{nomeDocumento}</p>;
    $[1] = nomeDocumento;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== documento.status) {
    t3 = documento.status === "carregando" && <CarregandoDocumento />;
    $[3] = documento.status;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== documento.status || $[6] !== documento.url || $[7] !== registrarFalhaDoVisor) {
    t4 = documento.status === "pronto" && <DocumentoPdfVisor url={documento.url} onErro={registrarFalhaDoVisor} />;
    $[5] = documento.status;
    $[6] = documento.url;
    $[7] = registrarFalhaDoVisor;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== documento.status) {
    t5 = documento.status === "indisponivel" && <EmptyState icon={<FeatherFileText />} title={"Documento de teste indispon\xEDvel"} description={"Este documento n\xE3o est\xE1 dispon\xEDvel para esta simula\xE7\xE3o."} />;
    $[9] = documento.status;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== documento.status || $[12] !== tentarDeNovo) {
    t6 = documento.status === "erro" && <Alert role="alert" variant="error" tone="filled" icon={<FeatherAlertCircle />} title={"N\xE3o foi poss\xEDvel exibir o documento de teste."} description="Tente abrir o documento novamente." actions={<Button variant="neutral-secondary" size="small" onClick={tentarDeNovo}>Tentar novamente</Button>} />;
    $[11] = documento.status;
    $[12] = tentarDeNovo;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== documento.status || $[15] !== tentarDeNovo) {
    t7 = documento.status === "expirado" && <Alert role="alert" variant="warning" tone="filled" icon={<FeatherClock />} title="O acesso ao documento expirou." description={"Por seguran\xE7a, o acesso vale por 60 segundos. Abra de novo para ver o documento."} actions={<Button variant="neutral-secondary" size="small" onClick={tentarDeNovo}>Abrir de novo</Button>} />;
    $[14] = documento.status;
    $[15] = tentarDeNovo;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t3 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6 || $[21] !== t7) {
    t8 = <div className="mt-5 overflow-hidden rounded-[8px] border border-solid border-neutral-200 bg-neutral-50">{t3}{t4}{t5}{t6}{t7}</div>;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t2 || $[24] !== t8) {
    t9 = <section aria-labelledby="documento-da-assinatura" className="bg-default-background flex min-w-0 flex-col rounded-[16px] border border-solid border-neutral-200 p-6">{t1}{t2}{t8}</section>;
    $[23] = t2;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
};